module.exports = __webpack_public_path__ + "img/28.19e58358.png";